'use strict';

/**
 * Adds anchor IDs to h2 elements in the given HTML content.
 */
function addAnchorsToHeadings() {
    $('.blog-content h2').each(function() {
        const $heading = $(this);
        const headingText = $heading.text().trim();
        const anchor = headingText.toLowerCase()
            .replace(/[^\w\s-]/g, '') // Remove non-word chars (except spaces and hyphens)
            .replace(/\s+/g, '-'); // Replace spaces with hyphens
        $heading.attr('id', anchor);
    });
}

/**
 * Generates a blog index based on the h2 elements with IDs in the given HTML content.
 */
function generateBlogIndex() {
    const $blogContent = $('.blog-content');
    const $h2Elements = $blogContent.find('h2[id]');
    
    if ($h2Elements.length === 0) {
        return null;
    }

    const indexItems = $h2Elements.map(function() {
        const $h2 = $(this);
        const id = $h2.attr('id');
        const title = $h2.text();
        return `<li><a href="#${id}">${title}</a></li>`;
    }).get();

    return `<ul>${indexItems.join('')}</ul>`;
}

function initTableOfContents() {
    addAnchorsToHeadings();
    
    const blogIndex = generateBlogIndex();
    if (blogIndex) {
        const $blogIndexContainer = $('<div class="blog-index"></div>').html(blogIndex);
        $('.generated-table-of-content').prepend($blogIndexContainer);
    } else {
        $('.table-of-contents').addClass('d-none');
        $('.bottom-sheet-trigger-container').addClass('d-none');
    }

    $('.table-of-contents li a').on('click', function() {
        const $visibleSheet = $('.bottom-sheet-content.show');
        if ($visibleSheet.length) {
            $(document).trigger('closeBottomSheetRequest', { targetId: $visibleSheet });
        }
    });
}

module.exports = {
    initTableOfContents: initTableOfContents
};